import React from "react";
import { marqueeTexts, LOGO_URL } from "../../data/mockData";

const MarqueeSection = ({ variant = "primary" }) => {
  const items = [...marqueeTexts, ...marqueeTexts, ...marqueeTexts];

  return (
    <div
      className={`relative overflow-hidden py-4 ${
        variant === "primary"
          ? "bg-gradient-to-r from-yellow-500/10 via-yellow-400/5 to-yellow-500/10 border-y border-yellow-400/20"
          : "bg-[#0d1a0d] border-y border-[#1a3a1a]"
      }`}
    >
      <div className="marquee-track flex items-center gap-8 whitespace-nowrap">
        {items.map((text, i) => (
          <React.Fragment key={i}>
            <span
              className={`font-bold text-sm uppercase tracking-wider ${
                variant === "primary" ? "text-yellow-400" : "text-gray-400"
              }`}
            >
              {text}
            </span>
            <img
              src={LOGO_URL}
              alt="MRS"
              className="w-6 h-6 rounded-full"
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export const PartnersMarquee = () => {
  const partners = [
    "CoinMarketCap",
    "CoinGecko",
    "Binance",
    "MEXC",
    "Bitget",
    "PancakeSwap",
    "Ethereum",
  ];
  const allPartners = [...partners, ...partners, ...partners];

  return (
    <div className="relative overflow-hidden py-6 bg-[#0d1a0d] border-y border-[#1a3a1a]">
      <div className="marquee-track-slow flex items-center gap-12 whitespace-nowrap">
        {allPartners.map((name, i) => (
          <React.Fragment key={i}>
            <div className="flex items-center gap-2 opacity-60 hover:opacity-100 transition-opacity duration-300">
              <div className="w-8 h-8 rounded-full bg-[#1a3a1a] flex items-center justify-center text-yellow-400 text-xs font-bold">
                {name.charAt(0)}
              </div>
              <span className="text-gray-300 text-sm font-medium">{name}</span>
            </div>
            <img
              src={LOGO_URL}
              alt="MRS"
              className="w-5 h-5 rounded-full opacity-30"
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default MarqueeSection;
